<template>
  <div>
    <b-row>
      <b-col :md="isEdit ? 9 : 12">
        <validation-observer ref="contractValidations">
          <section class="">
            <b-row>
              <b-col md="4">
                <b-form-group :label="$t('clients.client') + ':'">
                  <!-- <lazy-loading-select
                    :options="getClientsList"
                    @fetch="FETCH_CLIENTS_LIST"
                  /> -->
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('clients.client')"
                    rules="required"
                  >
                    <vue-autosuggest
                      v-model="client_title"
                      :suggestions="suggestOptions"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: $t('generals.search'),
                      }"
                      :limit="10"
                      :get-suggestion-value="(option) => option.item.title"
                      @selected="onSelected"
                      @input="searchClients"
                    >
                      <template slot-scope="{ suggestion }">
                        <div class="d-flex align-items-center">
                          <div class="detail ml-50">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.title }}
                            </b-card-text>
                            <b-card-text>
                              {{ suggestion.item.phones }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contract.customer_name')"
                  rules="required"
                >
                  <b-form-group
                    class="mb-0"
                    :label="$t('clients.customer') + ':'"
                  >
                    <div class="d-flex align-items-start">
                      <v-select
                        v-model="contract.customer"
                        :options="getOneClient.employee"
                        :reduce="(customer) => customer.id"
                        :disabled="!selected_client"
                        label="name"
                        class="w-100 mr-1"
                      />
                      <b-button
                        v-b-modal.employee-modal
                        variant="primary"
                        :disabled="!selected_client"
                      >
                        <feather-icon icon="PlusIcon" />
                      </b-button>
                    </div>
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('objects.installment')"
                  rules="required"
                >
                  <b-form-group
                    class="mb-0"
                    :label="$t('objects.installment') + ':'"
                  >
                    <div class="d-flex align-items-start">
                      <v-select
                        v-model="contract.calculation"
                        :options="GET_ONE_FLAT.calculations"
                        :reduce="(calculation) => calculation.id"
                        :get-option-label="
                          (calc) => calc.payment_in_percent.value
                        "
                        class="w-50 mr-1"
                      />
                      <b-button
                        class="w-50"
                        variant="info"
                        @click="openGridSidebar"
                      >
                        <feather-icon icon="GridIcon" />
                        {{
                          isEdit
                            ? $t('contract.change_flat')
                            : $t('contract.select_flat')
                        }}
                      </b-button>
                    </div>
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group :label="$t('contract.template') + ':'">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('contract.template')"
                    rules=""
                  >
                    <!-- <v-select
                      v-model="contract.template"
                      :options="GET_CONTRACT_TEMPLATES_FILE.results"
                      label="title"
                      @input="templateSelect"
                    /> -->
                    <LazySelect
                      :filters="{ page_size: 15 }"
                      v-model="contract.template"
                      :options="GET_CONTRACT_TEMPLATES_FILE"
                      :get-option-label="(temp) => temp.title"
                      :fetch="FETCH_CONTRACT_TEMPLATES_FILE"
                      class="bg-white"
                      @input="templateSelect"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4" v-if="selected_flat.price_per_kv">
                <b-form-group :label="$t('objects.price_per_m') + ':'">
                  <p class="mt-50 cursor-pointer" @click="changePricePerKv">
                    <b>{{
                      $_moneyFormatter(newPrice || selected_flat.price_per_kv)
                    }}</b>
                  </p>
                </b-form-group>
              </b-col>
            </b-row>
          </section>
          <template-formation
            v-if="isEdit"
            :document-subject="contract.document"
          />
          <!-- <pdf-content-new
            v-if="contract.template && !isEdit"
            :contract-content="GET_ONE_CONTRACT_TEMPLATE_FILE.contract"
          /> -->
          <embed
            v-if="GET_ONE_CONTRACT_TEMPLATE_FILE.contract && !isLoading"
            :src="GET_ONE_CONTRACT_TEMPLATE_FILE.contract"
            type="application/pdf"
            width="100%"
            height="600px"
          />

          <p v-if="isLoading" class="text-center">Загрузка...</p>

          <section class="d-flex justify-content-end">
            <b-button
              class="mr-1"
              @click="$router.push({ name: 'unsigned-contracts' })"
            >
              {{ $t('generals.back') }}
            </b-button>
            <b-button variant="primary" @click="saveClick(contract)">
              {{ $t('generals.save') }}
            </b-button>
          </section>
        </validation-observer>
      </b-col>
      <b-col v-if="isEdit" md="3">
        <b-card :title="$t('contract.version_history_and_additional')">
          <history-timeline
            :history="GET_CONTRACTS.results"
            @showClicked="showHistory"
          />
        </b-card>
      </b-col>
    </b-row>
    <customer-modal :parent_id="getOneClient.id" @success="selectClient" />
    <b-sidebar v-model="grid_sidebar" width="100vw">
      <filter-for-grid
        :views-dropdown="false"
        :filters="[]"
        :query-params.sync="query_params"
        @apartmentChanged="apartmentSelect"
        @objectChanged="objectSelect"
      />
      <b-card>
        <b-overlay :show="chess_overlay" rounded="lg" opacity="0.6">
          <vue-selecto
            :data="GET_CHECKERBOARD_LAYOUT"
            :sidebar="true"
            :filter="query_params"
            @flatSelected="openRightSidebar"
          />
        </b-overlay>
      </b-card>
      <right-sidebar
        v-model="right_sidebar"
        :item="selected_flat"
        :flat-choosing="true"
        @photoClicked="showInLargeSize"
        @flatChoose="flatChosen"
      />
      <left-sidebar v-model="left_sidebar" :image="selected_image" />
    </b-sidebar>

    <ChangePricePerKv
      :price="newPrice || selected_flat.price_per_kv"
      :flat-id="selected_flat.id"
      @updatePrice="updatePrice"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BButton,
  BCard,
  BSidebar,
  BOverlay,
  BCardText,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { required } from '@validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { VueAutosuggest } from 'vue-autosuggest'
import formatters from '@/mixins/extra'
import TemplateFormation from './components/templateFormation.vue'
import HistoryTimeline from './components/historyTimeline.vue'
import customerModal from '../Clients/components/EmployeeModal.vue'
import download from '@/mixins/download'
import filterForGrid from '../MyObjects/Apartments/components/filterForGrid.vue'
import vueSelecto from '@/components/vueSelecto.vue'
import rightSidebar from '../MyObjects/Apartments/components/flatSidebar.vue'
import leftSidebar from '../MyObjects/Apartments/components/leftImageSidebar.vue'
import pdfContentNew from './components/pdfContentNew.vue'
import useJwt from '@/auth/jwt/useJwt'
import ChangePricePerKv from './components/ChangePricePerKv.vue'
import LazySelect from '@/components/LazySelect.vue'

export default {
  components: {
    TemplateFormation,
    BRow,
    BCol,
    BFormGroup,
    VSelect,
    HistoryTimeline,
    customerModal,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BCard,
    BSidebar,
    BOverlay,
    filterForGrid,
    vueSelecto,
    rightSidebar,
    leftSidebar,
    pdfContentNew,
    VueAutosuggest,
    BCardText,
    ChangePricePerKv,
    LazySelect,
  },
  mixins: [formatters, download],
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      required,
      chess_overlay: false,
      contract: {
        // date: '',
        document: {
          header: '',
          main_part: '',
          clauses: [
            {
              title: '',
              subclauses: [{}],
            },
          ],
        },
        // document: {
        //   header: 'об инвестировании строительства жилого дома.\n(На основании статьи 354, 361 Гражд.К.Руз.)',
        //   main_part: '<p>г. Ташкент.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;«10» март «2021» год.</p><p>&nbsp;&nbsp;&nbsp;ООО «GRAND CAPITAL», именуемое в дальнейшем «ЗАСТРОЙЩИК» в лице Генерального Директора&nbsp;Axmadjanov E. O. действующего на основании Устава, в соответствии с решением&nbsp;Хокима г.Ташкента № 1711 от 30 ноября 2018 года, предусматривающего выделение земельного участка 0,55 га по адресу: г.Ташкент, Яккасарайский&nbsp;район, массив Кушбеги, для строительства жилого комплекса «SOLARIS», разрешение градостроительного совета за № 31-941/А.,&nbsp;31-1320/А действующего с одной стороны, и гражданин(ка) (Серия: «AA» «», дата выдачи – 20.06.2014год.), именуемый в дальнейшем «ИНВЕСТОР», действующий от своего имени, с другой стороны, заключили настоящий договор на основании заявления от «10» март «2021» года нижеследующем:</p>',
        //   clauses: [
        //     {
        //       title: '\tПРЕДМЕТ ДОГОВОРА',
        //       subclauses: [
        //         {
        //           key: '1.1',
        //           value: '<p>⦁\t«Застройщик» осуществляет строительство в соответствии с градостроительными нормами в целях обеспечения нормального функционирования, использования жилых квартир, нежилых помещений в жилом комплексе «SOLARIS» (далее по тексту договора именуемый «Комплекс») по адресу: г.Ташкент, Яккасарайский&nbsp;район, массив Кушбеги, а также их дальнейшей реализации.</p>',
        //         },
        //         {
        //           key: '1.2',
        //           value: '<p>\t«Застройщик» согласен на участие с инвестиционной деятельностью «Инвестора» в строительстве «Комплекса», путём и в виде внесения инвестиций в денежной форме в полном объеме с последующей передачей «Застройщиком» «Инвестору» права собственности на жилое помещение (далее по тексту «Объект») из состава «Комплекса SOLARIS» со следующими параметрами: Блок «G1- 4/7/4», 4-подъезд,&nbsp;2х-комнатная квартира, расположенная на 7-этаже жилого дома, общей площадью помещения (коробка)&nbsp;- 80 м², исходя из замера площади квартиры от основных стен, путём последующего заключения нотариально заверенного основного договора купли-продажи. Допускается аргументированное в письменной форме уменьшение или увеличение (соответственно с последующими перерасчетами стоимости «Объекта») предоставляемой площади, указанной в настоящем пункте, в случае технической невозможности ее предоставления, связанной с конструктивными особенностями строящегося «Комплекса» («Объекта»).&nbsp;</p>',
        //         },
        //         {
        //           key: '1.3',
        //           value: '<p>\tСтоимость предоставляемого жилого помещения, указанного в пункте 1.2 настоящего договора составляет ??? 000 000 (восемьдесят четыре миллиона) сум с учетом НДС (исходя из расчета стоимости 1 м² площади предоставляемого жилого помещения&nbsp;800 000 (миллиона восемьсот тысяч) сўм с учетом НДС). Сумма и график уплаты инвестиционного взноса являются договорным, Размер первоначального инвестиционного взноса составляет 30% от общей стоимости жилого помещения в сумме ??? 200 000 (миллионов двести тысяч) сўм и уплачивается с даты подписания настоящего договора в течении 5 банковских дней. Сумма последующих ежемесячных инвестиционных взносов в размере ?? 866 667 (двадцть девять миллионов восемьсот шестьдесят шесть тысяч шестьсот шестьдесят семь) сум, на 9 месяцев, от 10.03.2020 до 30.12.2020 года, оплачивается «Инвестором» до конца каждого следующего месяца вплоть до полного погашения стоимости жилого помещения, указанной в данном пункте.</p><p>Передача «Объекта» и оформление перехода права собственности осуществляется после окончания строительства «Комплекса» и сдачи квартир в государственную эксплуатацию (включая государственную регистрацию «Застройщиком» права собственности на «Комплекс»), а также полной оплаты за предоставляемое недвижимое имущество.</p><p>Передача «Инвестором» в качестве инвестиционного взноса денежных средств «Застройщику», проводится путём безналичного или наличного внесения денежных средств в национальной валюте РУз., на расчётный счёт «Застройщика»:&nbsp;2020 8000 1006 9104 0001 в&nbsp;АТИБ «Ипотека Банк» Чиланзарский филиал, МФО: 00997</p>',
        //         },
        //         {
        //           key: '1.4',
        //           value: '<p>\t«Инвестор» осуществляя инвестиционную деятельность, вносит инвестиции по настоящему договору в виде передачи «Застройщику» денежных средств согласно пункту 1.3.</p>',
        //         },
        //         {
        //           key: '1.5',
        //           value: '<p>\t«Застройщик» является участником инвестиционной деятельности, при необходимости заказчиком подрядных, субподрядных работ в течение строительства «Комплекса», пользователем и распорядителем инвестиционного взноса. Подписанием настоящего договора «Инвестор» наделяет «Застройщика» полномочиями: владением, пользованием и распоряжением инвестиционными взносами по самостоятельному определению целей и порядка их использования в целях завершения строительства и функционирования «Комплекса» в соответствии с градостроительными нормами, действующими на территории Республики Узбекистан. Расчетный предварительный срок окончания строительства «Комплекса» 30 декабря 2021 года.</p>',
        //         },
        //         {
        //           key: '1.6',
        //           value: '<p>\t«Застройщик» в целях обеспечения инвестиционной деятельности «Инвестора» заключает от своего имени все необходимые договора, для осуществления строительства «Комплекса» в целом, и далее являясь заказчиком по договорам строительного подряда или субподряда, принимает на себя выполнение всех обязательств, предусмотренных указанными договорами.</p>',
        //         },
        //         {
        //           key: '1.7',
        //           value: '<p>\t«Объект», на строительство которого «Инвестором» вносятся инвестиции, после завершения строительства «Комплекса» и сдачи его в эксплуатацию, при последующей передаче «Инвестору» права собственности, будет иметь следующий состав и объём выполненных работ:</p>',
        //         },
        //         {
        //           key: '1.8',
        //           value: '<p>⦁\tОтделочные работы: устанавливаются по наружным стенам окна, входная дверь</p>',
        //         },
        //         {
        //           key: '1.9',
        //           value: '<p>\tЭлектромонтажные работы: выполняется подводка электрического кабеля к щиту на лестничной площадке</p>',
        //         },
        //         {
        //           key: '1.10',
        //           value: '<p>\tСантехнические работы: а) выполняется трубная разводка холодной воды и канализации на уровне выхода из центральных стояков общего пользования.</p>',
        //         },
        //         {
        //           key: '1.11',
        //           value: '<p>\tГазификация: выполняется трубная подводка бытового газа на кухню</p>',
        //         },
        //         {
        //           key: '1.12',
        //           value: '<p>\tТелефонизация: выполняется подводка телефонного провода к щиту на лестничной площадке</p>',
        //         },
        //       ],
        //     },
        //     {
        //       title: 'ПРАВА И ОБЯЗАННОСТИ СТОРОН',
        //       subclauses: [
        //         {
        //           key: '2.1',
        //           value: '<p>\tПрава и обязанности «Застройщика»</p>',
        //         },
        //         {
        //           key: '2.1.1',
        //           value: '<p>\t«Застройщик» обязуется передать «Инвестору» жилое помещение, указанное в пункте 1.2 настоящего договора согласно акта приема-передачи, нотариально заверенного основного договора и документы на право владения нежилой площадью, включая необходимую бухгалтерскую документацию согласно налогового законодательства РУз, в течение 40 (сорок) банковских дней&nbsp;после уведомления «Застройщиком» о готовности к оформлению «Объекта» к сделке, а также при условии его полной оплаты и внесения инвестиционных взносов «Инвестором» в строительство «Комплекса». Датой полной оплаты считается дата последнего инвестиционного взноса, подтвержденного банком. Датой готовности «Объекта» к сделке считается дата государственной регистрации права собственности «Комплекса»</p>',
        //         },
        //         {
        //           key: '2.1.2',
        //           value: '<p>\tВ случае, если завершение строительства и сдачи «Комплекса» в эксплуатацию не может быть окончено в предусмотренный настоящим договором срок, «Застройщик» не позднее, чем за 10 (десять) календарных дней, до истечения срока, указанного в пункте 1.5, обязан направить «Инвестору» извещение об изменении срока завершения строительства и сдачи в эксплуатацию (мотивированно указав причину задержки), для заключение дополнительного соглашения или пролонгации.</p>',
        //         },
        //         {
        //           key: '2.1.2',
        //           value: '<p>\tСообщить «Инвестору» по адресу: __________________________________________________________________________________________________________________________________________________(в том числе указать номер телефона/телеграмма, е-мейл), путем письменного обращения с почтовым уведомлением даты сдачи в эксплуатацию «Комплекса», его готовности к сделкам и полного погашения инвестиционных платежей, с целью инициирования процедуры заключения основного договора, с нотариальным заверением и необходимости оформления документации (кадастрового свидетельства) на приобретения права собственности на жилье в установленные настоящим договором сроки.</p>',
        //         },
        //         {
        //           key: '2.1.3',
        //           value: '<p><strong><u>«Застройщик» обязуется выполнять требования органов государственной власти на местах и органов государственного управления, предъявляемые в пределах их компетенции, в части налогообложения, ведения, завершения и надлежащего оформления строительства объектов жилого и нежилого фонда</u></strong></p>',
        //         },
        //         {
        //           key: '2.1.4',
        //           value: '<p>«Застройщик» обязуется получить правоустанавливающий документ, подтверждающей право собственности на «Комплекс» (включая государственную регистрацию) не позднее шести месяцев после срока окончания строительства, указанного в пункте 1.5 настоящего договора. И передать «Инвестору» право собственности на «Объект», путём заключения нотариального договора купли-продажи «Объекта» с «Инвестором». 60 m<sup>2</sup></p>',
        //         },
        //         {
        //           key: '2.2',
        //           value: '<p>\tПрава и обязанности «Инвестора»</p>',
        //         },
        //         {
        //           key: '2.2.1',
        //           value: '<p>\t«Инвестор» обязуется своевременно вносить инвестиционные взносы «Застройщику» в соответствии и в порядке, установленным условиями пункта 1.3. настоящего договора.</p>',
        //         },
        //         {
        //           key: '2.2.2',
        //           value: '<p>\tС момента подписания настоящего договора письменно подтверждать «Застройщику» об изменениях своих реквизитов по адресу: г. Ташкент, Чиланзарский район, улица Лутфий, дом 49, тел. (71) 209-77-77, Генеральному Директору&nbsp;ООО «GRAND CAPITAL» Axmadjanov E. O..., включая место жительства, адрес работы, изменения фамилии, смерти (заинтересованные лица на правах наследования) и другие обстоятельства, способных повлиять на выполнение обязательств,&nbsp;как «Инвестора», так и «Застройщика» по настоящему договору;</p>',
        //         },
        //         {
        //           key: '2.2.3',
        //           value: '<p>\tВ течении 40 (сорок) банковских дней после получения уведомления о готовности «Комплекса» к оформлению и, кроме того полного погашения инвестиционных платежей, «Инвестор» обязан заключить в порядке ст. 361 Гражданского Кодекса РУз основной договор с «Застройщиком» с нотариальным заверением, предоставив при этом необходимую личную документацию, подтверждающую право получения жилой площади, указанную в пункте 1.2 настоящего договора, принять жилое помещение согласно акта приема-передачи и оформить свидетельство на приобретение права собственности на предоставляемое нежилое помещение в Государственном предприятии землеустройства и кадастра недвижимости Яккасарайского района, а также в местной коммунальной эксплуатационной службе с заключением договора на обслуживание нежилое помещение в установленном порядке</p>',
        //         },
        //         {
        //           key: '2.2.4',
        //           value: '<p>\t«Инвестор» обязан возмещать убытки, причинённые «Застройщику» неисполнением или ненадлежащим исполнением договора.</p>',
        //         },
        //         {
        //           key: '2.2.5',
        //           value: '<p>\tНе вмешиваться без согласования с «Застройщиком» в процесс строительства и производить перепланировку жилья, самовольное установление окон, дверей и другого оборудования до момента сдачи «Комплекса» в эксплуатацию и оформления необходимой документации на право собственности на «Объект»</p>',
        //         },
        //         {
        //           key: '2.2.6',
        //           value: '<p>\t«Инвестор» не вправе передавать свои права и обязанности по договору третьей стороне без письменного согласия «Застройщика».\\</p>',
        //         },
        //         {
        //           key: '2.2.7',
        //           value: '<p>«Инвестор» имеет право, в сопровождении представителя «Застройщика», в согласованное время, осуществлять визуальное наблюдение за ходом и качеством строительно-монтажных отделочных работ, не вмешиваясь при этом в оперативно-хозяйственную деятельность «Застройщика».</p>',
        //         },
        //         {
        //           key: '2.2.8',
        //           value: '<p>«Инвестор» имеет право потребовать расторжения договора и возврата инвестиционного взноса в случае необоснованной задержки «Застройщиком» срока завершения строительства и сдачи в эксплуатацию «Комплекса», предусмотренного пунктом 1.5 более чем на 3 (три) месяца.</p>',
        //         },
        //       ],
        //     },
        //     {
        //       title: 'ОСОБЫЕ УСЛОВИЯ ОФОРМЛЕНИЯ ПРАВА СОБСТВЕННОСТИ НА ОБЪЕКТ',
        //       subclauses: [
        //         {
        //           key: '3.1',
        //           value: '<p>Передача «Застройщиком» права собственности «Инвестору» на «Объект» производится путём заключения нотариального договора купли-продажи «Объекта», с возложением на «Инвестора» обязанности по оплате государственной пошлины за оформление договора и регистрации права собственности.</p>',
        //         },
        //         {
        //           key: '3.2',
        //           value: '<p>Приём-передача «Объекта», осуществляется не ранее одного дня и не позже трёх календарных дней со дня даты заключения нотариального договора, с подписанием акта приёма-передачи и оформлением счёта-фактуры. С этого момента «Объект» снимается с баланса «Застройщика» и на «Инвестора» переходит бремя содержания «Объекта» (уплата коммунальных платежей, налоговых сборов и других обязательных платежей), связанных с содержанием, правом собственности и пользования «Объектом».</p>',
        //         },
        //         {
        //           key: '3.3',
        //           value: '<p>\tСтоимость «Объекта» отражаемая в нотариальном договоре купли-продажи, заключаемого между «Застройщиком» и «Инвестором», отражается в счёте-фактуре, выписываемой «Застройщиком» и составляет общую сумму переданного «Инвестором» инвестиционного взноса в национальной валюте РУз., «сўм».</p>',
        //         },
        //       ],
        //     },
        //     {
        //       title: 'ОТВЕТСТВЕННОСТЬ СТОРОН',
        //       subclauses: [
        //         {
        //           key: '4.1',
        //           value: '<p>За неисполнение или ненадлежащее исполнение обязательств по настоящему договору, в части сроков, порядка и условии внесения инвестиционного взноса, «Инвестор» выплачивает «Застройщику» пеню в размере 0,5% от размера задолженности за каждый день просрочки от графика уплаты, но не более 10% от общего размера инвестиционного взноса согласно настоящего договора. Взыскание суммы пени является правом, а не обязанностью «Застройщика». Нарушение «Инвестором» сроков внесения полной суммы инвестиционного взноса освобождает «Застройщика» от ответственности за просрочку выполнения обязательств по оформлению права собственности «Инвестора» на «Объект».</p>',
        //         },
        //         {
        //           key: '4.2',
        //           value: '<p>В случае расторжения договора в связи с не внесением, не полным внесением инвестиционного взноса, невозможностью или нежеланием «Инвестора» продолжать внесение денежных средств в счёт инвестиционного взноса и получать в собственность «Объект», «Застройщик», при возврате денежных средств «Инвестору», удерживает штраф в размере 10%, в качестве потерянной выгоды от сделки, от общей суммы взносов, внесенных на расчетный счет «Застройщика» на момент расторжения настоящего договора</p>',
        //         },
        //         {
        //           key: '4.3',
        //           value: '<p>За неисполнение или ненадлежащее исполнение обязательств по настоящему договору Стороны несут ответственность в порядке статьи 361, 377 Гражданского кодекса РУз и с другими нормативными актами.</p>',
        //         },
        //         {
        //           key: '4.4',
        //           value: '<p>\tЗа необоснованное нарушение срока выполнения,&nbsp;указанного в пункте 2.1.1 настоящего договора «Застройщиком», последний выплачивает «Инвестору»&nbsp;неустойку в виде пени в размере 0,1 % за каждый день просрочки от общей стоимости «Объекта», указанной в пункте 1.3 настоящего договора, но не более 3%&nbsp;от нее.</p>',
        //         },
        //         {
        //           key: '4.5',
        //           value: '<p>За нарушение пункта 2.2.5 настоящего договора без уважительных причин «Инвестор» выплачивает «Застройщику» неустойку в виде штрафа в размере 0.1 %&nbsp;от общей стоимости «Объекта», указанной в пункте 1.3. настоящего договора.</p>',
        //         },
        //         {
        //           key: '4.6',
        //           value: '<p>Ответственность сторон за не исполнение или ненадлежащее исполнение обязательств по настоящему договору определяется соответственно Гражданским Кодексом РУз,. Законом РУз. «О договорно-правовой базе деятельности хозяйствующих субъектов» и другими нормативными актами действующего законодательства РУз</p>',
        //         },
        //         {
        //           key: '4.7',
        //           value: '<p>Споры, возникающие из данного договора или в связи с ним, подлежат разрешению в порядке, предусмотренном действующим законодательством РУз., в суде общей гражданской юрисдикции, если «Инвестор» - физическое лицо, или в хозяйственном суде, если «Инвестор» - юридическое лицо, по общим правилам судопроизводства</p>',
        //         },
        //       ],
        //     },
        //     {
        //       subclauses: [
        //         {
        //           value: '<p><strong>hiuhuihuihu <u>knjk</u> </strong><em>mnokjoo m</em><sup><em>2</em></sup></p>',
        //           key: '5.1',
        //         },
        //       ],
        //       title: 'dssdvfgbfgfgbfgbdfgb',
        //     },
        //   ],
        // },
      },
      contract_id: null,
      pdfGen: false,
      selected_client: null,
      customer_info: {},
      client_options: [],
      client_query: {
        page: 1,
        page_size: 10,
        search: '',
        partial: true,
      },
      client_title: '',
      observer: null,
      grid_sidebar: false,
      right_sidebar: false,
      left_sidebar: false,
      query_params: {
        rooms_count_list: [],
        total_area_start: '',
        total_area_end: '',
        total_price_end: '',
        total_price_start: '',
        current_status: [],
      },
      selected_image: '',
      selected_flat: {
        current_status: {
          title: {},
        },
      },
      account_options: [],
      newPrice: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'GET_ONE_CONTRACT',
      'GET_CONTRACTS',
      'GET_CONTRACT_TEMPLATES_FILE',
      'GET_ONE_CONTRACT_TEMPLATE_FILE',
    ]),
    ...mapGetters('clients', [
      'getClientsList',
      'getOneClient',
      'GET_ONE_EMPLOYEE',
    ]),
    ...mapGetters('apartments', ['GET_APARTMENTS', 'GET_CHECKERBOARD_LAYOUT']),
    ...mapGetters('flats', ['GET_ONE_FLAT']),
    ...mapGetters('knowledgeBase', ['GET_ONE_CONSTRUCTOR']),
    hasNextPage() {
      return this.client_options.length < this.getClientsList.count
    },
    suggestOptions() {
      if (this.getClientsList.count && this.client_title) {
        return [{ data: this.getClientsList.results }]
      }
      return []
    },
  },

  watch: {
    'selected_flat.id'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.newPrice = null
      }
    },
  },

  mounted() {
    this.FETCH_CLIENTS_LIST(this.client_query).then(() => {
      this.client_options = this.getClientsList.results
    })
    this.SET_APARTMENT_CHECKERBOARD_LAYOUT([])
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.FETCH_CONTRACT_TEMPLATES_FILE({ page: 1, page_size: 15 })
    if (this.isEdit) {
      this.FETCH_ONE_CONTRACT(this.$route.params.id).then(() => {
        this.contract = this.GET_ONE_CONTRACT
        this.FETCH_CONTRACTS({ object_id: this.contract.object_id })
        this.FETCH_ONE_FLAT(this.contract.flat)
        this.FETCH_ONE_EMPLOYEE(this.contract.customer).then((customer_res) => {
          this.FETCH_ONE_CLIENT(customer_res.company).then(() => {
            this.selected_client = this.getOneClient
            // this.onSelected(this.selected_client)
            this.client_title = this.selected_client.title
          })
        })
        this.updateBreadcrumb()
      })
    } else {
      this.contract.flat = sessionStorage.getItem('selected_flat')
    }
  },
  methods: {
    ...mapActions('contracts', [
      'ADD_CONTRACT',
      'EDIT_CONTRACT',
      'FETCH_ONE_CONTRACT',
      'DOWNLOAD_CONTRACT_PDF',
      'FETCH_CONTRACTS',
      'FETCH_CONTRACT_TEMPLATES_FILE',
      'FETCH_ONE_CONTRACT_TEMPLATE_FILE',
    ]),
    ...mapActions('clients', [
      'FETCH_CLIENTS_LIST',
      'FETCH_ONE_CLIENT',
      'FETCH_ONE_EMPLOYEE',
    ]),
    ...mapActions('objects', [
      'FETCH_OBJECTS',
      'FETCH_ONE_OBJECT',
      'FETCH_ONE_PAYMENT_TYPE',
    ]),
    ...mapActions('apartments', [
      'FETCH_APARTMENTS_BY_OBJECT',
      'FETCH_APARTMENT_CHECKERBOARD_LAYOUT',
      'FETCH_APARTMENT_SECTIONS',
    ]),
    ...mapActions('flats', ['FETCH_ONE_FLAT']),
    ...mapActions('knowledgeBase', ['FETCH_ONE_CONSTRUCTOR']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    ...mapMutations('apartments', ['SET_APARTMENT_CHECKERBOARD_LAYOUT']),
    onSelected(option) {
      this.selected_client = this.$_removeObjectConnection(option.item)
      // const [phone] = option.item
      this.selected = option.item
      this.client_title = option.item.title
      this.selectClient()
      // const [phone] = option.item.phones
      // this.client = option.item
      // eslint-disable-next-line
    },
    saveClick(contract) {
      if (this.contract.flat) {
        const { qr, file, payment_method, author, action, ...rest } = contract
        if (this.isEdit) {
          this.contract = {
            object_id: contract.object_id,
            author: useJwt.getUserData().id,
            action: 'approve',
            ...rest,
          }
        }
        this.$refs.contractValidations.validate().then((success) => {
          if (success) {
            this.ADD_CONTRACT(this.contract)
              .then((resp) => {
                this.contract_id = resp.data.id
                this.pdfGen = true
                this.$_successToast(this.$t('generals.added'))
                sessionStorage.removeItem('selected_flat')
                this.$router.push({ name: 'unsigned-contracts' })
              })
              .catch((err) => {
                if (err.response.status === 406) {
                  this.$_showCustomModal(
                    this.$t('generals.please_confirm'),
                    this.$t('contract.contract_exists')
                  ).then((res) => {
                    if (res) {
                      const promises = []
                      err.response.data.forEach((el) => {
                        promises.push(
                          this.EDIT_CONTRACT({ id: el, is_active: false })
                        )
                      })
                      Promise.all(promises).then(() => {
                        this.saveClick(this.contract)
                      })
                    }
                  })
                }
                this.$_errorToast(this.$t('generals.error'))
              })
          }
        })
      } else {
        this.openGridSidebar()
      }
    },
    openGridSidebar() {
      this.grid_sidebar = true
      this.FETCH_OBJECTS()
    },
    openRightSidebar(flat) {
      this.selected_flat = flat
      this.FETCH_ONE_FLAT(flat.id).then(() => {
        this.selected_flat = this.GET_ONE_FLAT
      })
      this.right_sidebar = true
    },
    flatChosen(id) {
      this.contract.flat = id
      this.grid_sidebar = false
      // this.saveClick(this.contract)
    },
    updateBreadcrumb() {
      const [first, second] = this.$_removeObjectConnection(
        this.$route.meta.breadcrumb
      )
      second.text = this.GET_ONE_CONTRACT.contract_number
      console.log([first, second])
      this.UPDATE_BREADCRUMB([first, second])
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.clientsLoad)
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    objectSelect(object_id) {
      console.log(object_id)
      if (object_id) {
        this.rc_object = object_id
        this.FETCH_APARTMENTS_BY_OBJECT({ id: this.rc_object })
        this.FETCH_ONE_OBJECT(object_id).then((res) => {
          this.payment_type_options = res.payment_type
          this.FETCH_ONE_CONSTRUCTOR(res.brand).then(() => {
            console.log(this.GET_ONE_CONSTRUCTOR)
            this.account_options = this.GET_ONE_CONSTRUCTOR.account.banks
          })
        })
      }
    },
    apartmentSelect(apartment_id) {
      this.apartment = apartment_id
      if (apartment_id) {
        // this.FETCH_APARTMENT_SECTIONS(apartment_id)
        this.chess_overlay = true
        this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(apartment_id).then(() => {
          this.chess_overlay = false
        })
      }
    },
    infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const { scrollTop } = target.offsetParent
        console.log(scrollTop)
        this.client_query.page += 1
        this.FETCH_CLIENTS_LIST(this.client_query).then(() => {
          this.client_options.push(...this.getClientsList.results)
          this.$nextTick(() => {
            ul.scrollTop = scrollTop
          })
        })
      }
    },
    searchClients(search) {
      this.client_title = search
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.client_query.page = 1
        this.FETCH_CLIENTS_LIST({ search }).then(() => {
          this.client_options = this.getClientsList.results
        })
      }, 600)
    },
    selectClient() {
      this.FETCH_ONE_CLIENT(this.selected_client.id)
    },
    showHistory(item) {
      // this.FETCH_ONE_CONTRACT(id)
      this.$_getFile(item.file)
    },
    showInLargeSize(url) {
      this.selected_image = url
      this.left_sidebar = true
    },
    revertHistory(id) {
      console.log(id)
    },
    generationEnd() {
      this.$router.push({ name: 'unsigned-contracts' })
    },
    templateSelect(template) {
      this.isLoading = true
      this.$refs.contractValidations.validate().then((success) => {
        if (success) {
          this.FETCH_ONE_CONTRACT_TEMPLATE_FILE({
            flat_id: this.contract.flat,
            customer_id: this.contract.customer,
            id: template.id,
            calculation_id: this.contract.calculation,
          }).then(() => {
            this.contract.document = this.GET_ONE_CONTRACT_TEMPLATE_FILE.content
            this.isLoading = false
          })
        } else {
          this.isLoading = false
          this.contract.template = null
        }
      })
    },

    changePricePerKv() {
      this.$bvModal.show('change-price-per-kv')
    },

    updatePrice(price) {
      this.newPrice = price
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';

.clients-select-contracts-loader {
  text-align: center;
  color: #bbbbbb;
}
.clients-select-contracts ul {
  max-height: 200px;
}
</style>
